exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabla_serie {\n    height: 352px !important;\n    overflow-y: auto;\n    overflow-x: hidden;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/components/modals/serie-egreso-modal/serie-egreso-modal.component.css
// module id = ../../../../../src/app/components/modals/serie-egreso-modal/serie-egreso-modal.component.css
// module chunks = main